import { ChantContext } from "../../gregorio-chant/ChantContext";
import { TextSpan } from "../../gregorio-chant/structures/TextSpan";
import { ChantLayoutElement } from "../layout/ChantLayoutElement";

export class AboveLineText extends ChantLayoutElement {
  private _spans: TextSpan[] = [];

  constructor(
    context: ChantContext,
    spans: TextSpan[],
  ) {
    super(context);
    this._spans = spans;
    this.defaultStyle = {
      'font-family': this._context.lyricTextFont,
      'font-size': this._context.lyricTextSizePx + 'px',
      'font-kerning': 'normal',
    };
  }

  public performLayout(): void {
    // empty
  }

  private defaultStyle: { [key: string]: string };

  private get styleProperties(): string {
    return Object.keys(this.defaultStyle).map(key => key + ':' + this.defaultStyle[key]).join(';');
  }

  private createSingleSvgFragment(): SVGElement {
    const textEl = document.createElementNS('http://www.w3.org/2000/svg', 'text');
    textEl.setAttribute('x', String(this.bounds.x));
    textEl.setAttribute('y', String(this.bounds.y));
    textEl.setAttribute('text-anchor', 'start');
    textEl.setAttribute('font-style', 'italic');
    textEl.setAttribute('style', this.styleProperties);

    for (let i = 0; i < this._spans.length; i++) {
      const [spanEements] = this._spans[i].getSvgSpan(this._context, true, {});

      for (const spanEl of spanEements) {
        if (spanEl) {
          textEl.appendChild(spanEl);
        }
      }
    }

    return textEl;
  }

  public createSvgFragments(): SVGElement[] {
    return [
      ...super.createSvgFragments(),
      this.createSingleSvgFragment(),
    ];
  }
}
